import React from "react";
import SliderBanner from "../../component/slidercomponent/SliderBanner";
import { FaRegComment } from "react-icons/fa";
import { motion } from "framer-motion";

const HomeBanner = () => {
  return (
    <>
      <SliderBanner />
    </>
  );
};

export default HomeBanner;
